import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function fetchPromotions(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, additionalHeaders = {}, active = false } = params;

    invariant(baseUrl, 'baseUrl is a required param of fetchPromotions()');
    invariant(brandId, 'brandId is a required param of fetchPromotions()');
    invariant(country, 'country is a required param of fetchPromotions()');
    invariant(uberToken, 'uberToken is a required param of fetchPromotions()');
    invariant(clientId, 'clientId is a required param of fetchPromotions()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const queryBody = querystring.stringify({ active: active || undefined });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/promotion${queryBody ? `?${queryBody}` : ''}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'fetchPromotions',
    );
}
